import { render, staticRenderFns } from "./FutureFunds.vue?vue&type=template&id=9d495722&"
import script from "./FutureFunds.vue?vue&type=script&lang=ts&"
export * from "./FutureFunds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports